import React, { useState } from "react";
import styles from "./AddToCart.module.css";
import { BsCartPlus } from "react-icons/bs";
import { useSelector, useDispatch } from "react-redux";
import { addItemToCart } from "../../redux/userSlice";
import Swal from "sweetalert2";

function AddToCart({ product }) {
  const [quantity, setQuantity] = useState(1);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();
  const productSelected = useSelector((state) =>
    state.products.find((prod) => prod.name === product.name)
  );
  const productInCart = useSelector((state) =>
    state.cart.find((prod) => prod.name === product.name)
  );

  const handleClickMinus = () => {
    if (quantity === 1) {
      return quantity;
    } else if (quantity > 1) {
      return setQuantity(quantity - 1);
    }
  };

  const resetInput = () => {
    setQuantity(1);
  };

  const Toast = Swal.mixin({
    toast: true,
    position: "top",
    showConfirmButton: false,
    timer: 1500,
    timerProgressBar: true,
  });

  const handleClickPlus = () => {
    if (productSelected.stock > quantity) {
      return setQuantity(quantity + 1);
    } else {
      Toast.fire({
        icon: "error",
        title: `Lo sentimos solo quedan ${productSelected.stock} unidades `,
      });
    }
  };

  const addToCart = () => {
    if (productInCart && productSelected.stock < productInCart.qty + quantity) {
      Toast.fire({
        icon: "error",
        title: `Lo sentimos solo quedan ${productSelected.stock} unidades `,
      });
      return setError(`Lo sentimos, solamente hay ${product.stock} en stock.`);
    } else if (productSelected.stock < quantity) {
      Toast.fire({
        icon: "error",
        title: `Lo sentimos solo quedan ${productSelected.stock} unidades `,
      });
      return setError(`Lo sentimos, solamente hay ${product.stock} en stock.`);
    } else {
      setError(null);
      dispatch(
        addItemToCart({
          name: product.name,
          price: product.price,
          image: product.pictures[0].img1,
          qty: quantity,
          description: product.description,
        })
      );
      Toast.fire({
        icon: "success",
        title: `Se agrego ${quantity} ${product.name} al carrito `,
      });
      resetInput();
      //productSelected.stock = productSelected.stock - quantity;
    }
  };

  return (
    <>
      <form action="" className={styles.formQty + " d-flex"}>
        <div className={styles.btns + " d-flex align-items-center"}>
          <button
            type="button"
            className={styles.btn + " text-white"}
            onClick={() => handleClickMinus()}
          >
            -
          </button>
        </div>
        <input
          min={1}
          readOnly={true}
          type="number"
          name="quantity"
          value={quantity}
          className={styles.input + " text-muted"}
          onChange={(e) => setQuantity(e.target.value)}
        />
        <div className={styles.btns + " d-flex align-items-center"}>
          <button
            className={styles.btn + " text-white"}
            type="button"
            onClick={() => handleClickPlus()}
          >
            +
          </button>
        </div>
      </form>
      <button
        className={styles.btnAdd + " btn fw-semibold pb-1"}
        onClick={() => addToCart()}
        data-bs-toggle="offcanvas"
        data-bs-target="#offcanvasExample"
      >
        Agregar <BsCartPlus style={{ fontSize: "1rem" }} />
      </button>
      {/* <p className="mt-2 text-muted fs-6">{error}</p> */}
    </>
  );
}

export default AddToCart;
